import { createAction } from 'redux-actions';
import { CommissionStatusType } from '@wix/da-shared-react/pkg/types/commissions';

export type ChangeCommissionsGlobalStatusPayload = {
  isOpen: boolean;
};

export type ChangeAllCommissionsStatusPayload = {
  status: CommissionStatusType;
};

export const fetchCommissionsSuccess = createAction<any>(
  'COMMISSIONS.FETCH.SUCCESS'
);

export const changeAllCommissionsStatus = createAction<
  ChangeAllCommissionsStatusPayload
>('COMMISSION.CHANGE_ALL_COMMISSIONS_STATUS');

export const changeCommissionsGlobalStatus = createAction<
  ChangeCommissionsGlobalStatusPayload
>('COMMISSION.CHANGE_GLOBAL_STATUS');
